import type { ApolloError } from '@apollo/client';
import { useMemo } from 'react';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import notEmpty from '../../core/util/notEmpty';
import type { ProductOrderRestriction } from '../types';
import useProductOrderRestrictions from './useProductOrderRestrictions';

const useProductOrderRestriction = ({
    sku,
    skuList,
    skip,
}: {
    sku?: string;
    skuList?: string[];
    skip?: boolean;
}): {
    loading?: boolean;
    error?: ApolloError;
    restriction?: ProductOrderRestriction;
} => {
    const { store } = useStoreAndLanguageParams();

    const { data, loading } = useProductOrderRestrictions({
        skuList: sku ? [sku] : skuList,
        skip,
    });

    const result = useMemo(() => {
        if (!data) {
            return {
                restriction: {
                    store,
                    sku: sku || skuList?.[0] || '',
                },
            };
        }

        return {
            restriction: data.productListOrderRestriction.filter(item =>
                notEmpty(item.restrictionId)
            )[0],
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    if (loading) {
        return {
            loading: true,
        };
    }

    return result;
};

export default useProductOrderRestriction;
